import React, { useMemo } from "react";
import useSeo from "../seo/useSeo";
import useJsonLd from "../seo/useJsonLd";
import MergePdf from "../components/MergePdf";

export default function FusionPdfPage() {
  useSeo({
    title: "Fusion PDF – Fusionner plusieurs PDF en un seul | pdf-convert.fr",
    description:
      "Fusionnez facilement plusieurs fichiers PDF en un seul document. Réorganisez l’ordre. Conversion 100% locale.",
    canonical: "https://pdf-convert.fr/fusion-pdf",
  });

  const faqItems = [
    {
      q: "Comment fusionner plusieurs PDF ?",
      a: "Ajoutez plusieurs fichiers PDF, réorganisez l’ordre si besoin, puis lancez la fusion pour télécharger un seul PDF.",
    },
    {
      q: "Mes fichiers sont-ils envoyés sur un serveur ?",
      a: "Non. Tout se fait dans votre navigateur, sans envoi ni stockage.",
    },
    {
      q: "Puis-je choisir l’ordre des PDF ?",
      a: "Oui, vous pouvez déplacer les fichiers avant de fusionner.",
    },
  ];

  const faqJsonLd = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqItems.map((it) => ({
        "@type": "Question",
        name: it.q,
        acceptedAnswer: { "@type": "Answer", text: it.a },
      })),
    }),
    []
  );

  useJsonLd("faq-fusion-pdf", faqJsonLd);

  useJsonLd("breadcrumb-fusion-pdf", {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Accueil",
        item: "https://pdf-convert.fr/home",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Fusion",
        item: "https://pdf-convert.fr/fusion",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Fusion PDF",
        item: "https://pdf-convert.fr/fusion-pdf",
      },
    ],
  });

  return (
    <main style={{ maxWidth: 900, margin: "0 auto", padding: 16 }}>
      <h1>Fusion PDF</h1>
      <p style={{ textAlign: "center", color: "#666" }}>
        Fusionne plusieurs PDF en un seul fichier. Aucun envoi, tout se fait
        localement.
      </p>

      <MergePdf />
    </main>
  );
}
